
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AlertFilter": [
      "AlertFilterBoolean",
      "AlertFilterNumber",
      "AlertFilterString"
    ],
    "AlertFilterBase": [
      "AlertFilterBoolean",
      "AlertFilterNumber",
      "AlertFilterString"
    ],
    "AlertTypeFilter": [
      "AlertTypeFilterAccount",
      "AlertTypeFilterBoolean",
      "AlertTypeFilterCountry",
      "AlertTypeFilterDropdown",
      "AlertTypeFilterNumber",
      "AlertTypeFilterString",
      "AlertTypeFilterSupplier"
    ],
    "AlertTypeFilterBase": [
      "AlertTypeFilterAccount",
      "AlertTypeFilterBoolean",
      "AlertTypeFilterCountry",
      "AlertTypeFilterDropdown",
      "AlertTypeFilterNumber",
      "AlertTypeFilterString",
      "AlertTypeFilterSupplier"
    ],
    "CCMenuDebugTest": [
      "CCMenuDebugTestAllocations",
      "CCMenuDebugTestAvailabilities",
      "CCMenuDebugTestCCSupplierOrder",
      "CCMenuDebugTestClusterAssignment"
    ],
    "CheckoutResponse": [
      "GmCheckoutErrors",
      "PayByCardResponse",
      "PayByInvoiceResponse",
      "PayByTransferResponse"
    ],
    "CombinedInvoice": [
      "CCInvoice",
      "FlexInvoice",
      "FlexInvoiceAllTypes",
      "GMInvoice"
    ],
    "CombinedVendorStatement": [
      "VendorFlexInvoice",
      "VendorFlexInvoiceAllTypes",
      "VendorStatement"
    ],
    "GmServiceLocation": [
      "AccountLocation",
      "Address",
      "NewAccountLocation"
    ],
    "Invoice": [
      "CCInvoice",
      "GMInvoice"
    ],
    "NotificationEvent": [
      "NotificationEventEmail",
      "NotificationEventPush"
    ]
  }
};
      export default result;
    